import { useUtils } from "@/app/hooks/useUtils";

const ViewCommentModal = ({ appointmentNotes }) => {
  const { convertNoteToArray } = useUtils();
  const flage = appointmentNotes?.startsWith("<ol>");

  const notes = flage ? convertNoteToArray(appointmentNotes) : appointmentNotes?.split("||");
  const commentData = notes?.filter((item) => item?.trim() !== "")?.filter((item) => item !== "Other:");

  return (
    <ol type="1" className=" w-full border p-1 rounded-md -mt-5">
      {commentData?.map((com: string, idx) => {
        return (
          <li key={`${com}:${idx}`} className="flex  relative  justify-start pb-1  w-full">
            <p className="text-[10px]   text-black font-normal pl-2	">{com}</p>
          </li>
        );
      })}
    </ol>
  );
};
export default ViewCommentModal;
